import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/icons/times-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-79b3f174"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-bs-target"]
const _hoisted_2 = ["id", "aria-labelledby"]
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "carousel-inner" }
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["data-bs-target"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "carousel-indicators" }
const _hoisted_17 = ["data-bs-target", "data-bs-slide-to"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoImageAvailable = _resolveComponent("NoImageAvailable")!
  const _component_ImageContainer = _resolveComponent("ImageContainer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "image-container",
    style: _normalizeStyle('background-image: url(' + _ctx.imageUrl + ')')
  }, [
    (!_ctx.imageUrl)
      ? (_openBlock(), _createBlock(_component_NoImageAvailable, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.imageUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "image-blank-container",
          id: "gallery",
          "data-bs-toggle": "modal",
          "data-bs-target": '#imageModal' + _ctx.id
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "modal fade",
      id: 'imageModal' + _ctx.id,
      tabindex: "1",
      "aria-labelledby": 'Image Modal ' + _ctx.id,
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              id: 'imageCarousel' + _ctx.id,
              class: "carousel slide",
              "data-bs-ride": "carousel"
            }, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: image._id,
                    class: _normalizeClass(
                    image.active ? 'carousel-item active' : 'carousel-item'
                  )
                  }, [
                    _createVNode(_component_ImageContainer, {
                      class: "single-image",
                      imageUrl: image.lg_full
                    }, null, 8, ["imageUrl"])
                  ], 2))
                }), 128))
              ]),
              (_ctx.images.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "carousel-control-prev",
                    type: "button",
                    "data-bs-target": '#imageCarousel' + _ctx.id,
                    "data-bs-slide": "prev"
                  }, _hoisted_11, 8, _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.images.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "carousel-control-next",
                    type: "button",
                    "data-bs-target": '#imageCarousel' + _ctx.id,
                    "data-bs-slide": "next"
                  }, _hoisted_15, 8, _hoisted_12))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: image._id,
                    type: "button",
                    "data-bs-target": '#imageCarousel' + _ctx.id,
                    "data-bs-slide-to": index,
                    class: _normalizeClass(image.active ? 'active' : ''),
                    "aria-current": "true",
                    "aria-label": "Slide 1"
                  }, null, 10, _hoisted_17))
                }), 128))
              ])
            ], 8, _hoisted_6),
            _hoisted_18
          ])
        ])
      ])
    ], 8, _hoisted_2)
  ], 4))
}